//base 内部组件 参数设置
// import globalApi from "@/api/global";

const GlobalConfig = {
  getSelectOptions: {
    // api: globalApi.GetSelectItemsByCodes,
    defaultField: "isSelect", //默认选中项
    dataField: "data" //来源
  },
  dataList: {
    pageStartIndex: 0,
    pageField: "pageIndex", //页码
    sizeField: "pageSize", //每个数量
    dataField: "data.datas", //返回数据来源
    totalField: "data.total", //返回数据汇总
    isLoadingKey: "ISLOADING", //屏蔽请求loading专用
    finishedText: "没有更多了", //到底提示
    errorText: "请求失败，点击重新加载" //请求失败提示
  },
  form: {
    dataForm: {
      titleWidth: "60", // 所有项的标题宽度
      filterNullValues: true, // 获取数据时是否清除空值字段值
      autoLoadOptionsData: true, //自动加载请求
      autoSetDefaultValue: true, //自动设置默认值 根据key
      errorToast: true, //是否弹出提示
      errorText: "请填写" //错误提示
    },
    formAutoComplete: {
      valueField: "value",
      dataField: "data"
    },
    formCheckbox: {
      disabledField: "disabled",
      readonlyField: "readonly",
      valueField: "id",
      labelField: "text"
    },
    formMultiple: {
      searchFilter: ["text", "simpleCode"],
      valueField: "id",
      labelField: "text"
    },
    formRadio: {
      disabledField: "disabled",
      readonlyField: "readonly",
      valueField: "id",
      labelField: "text"
    },
    formSearchList: {
      searchKeyField: "name",
      valueField: "name",
      pageStartIndex: 0,
      pageField: "pageIndex", //页码
      sizeField: "pageSize", //每个数量
      dataField: "data.datas", //返回数据来源
      totalField: "data.total" //返回数据汇总
    },
    formSelect: {
      searchFilter: ["text", "simpleCode"],
      valueField: "Id",
      labelField: "Text"
    },
    formStepper: {
      inputWidth: "32px",
      buttonSize: "24px",
      decimalLength: 2
    },
    formTreeSelect: {
      searchFilter: ["text", "simpleCode"],
      valueField: "id",
      labelField: "text",
      childrenField: "children",
      disabledField: "disabled"
    },
    formCascader: {
      fieldNames: { text: "text", value: "value", children: "children" }
    }
  }
};

//dataList
export const dataListConfig = GlobalConfig.dataList;
//formAutoComplete
export const formAutoCompleteConfig = GlobalConfig.form.formAutoComplete;
//formCheckbox
export const formCheckboxConfig = GlobalConfig.form.formCheckbox;
//formMultiple
export const formMultipleConfig = GlobalConfig.form.formMultiple;
//formRadio
export const formRadioConfig = GlobalConfig.form.formRadio;
//formSearchList
export const formSearchListConfig = GlobalConfig.form.formSearchList;
//formSelect
export const formSelectConfig = GlobalConfig.form.formSelect;
//formStepper
export const formStepperConfig = GlobalConfig.form.formStepper;
//formTreeSelect
export const formTreeSelectConfig = GlobalConfig.form.formTreeSelect;
//formCascader
export const formCascaderConfig = GlobalConfig.form.formCascader;

//全部
export default GlobalConfig;
